<h1 class="page-title">Felvételek</h1>

<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/felvetelek/tanitasok']">Tanítások</a></p>
<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/felvetelek/sorozatok']">Sorozatok</a></p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/records.component.html